import styled from 'styled-components';
import { MOBILE_L } from '../hooks/screen';

export const ConfigScreenWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 100px;
  ${'' /* margin-top: 100px; */}

  @media (max-width: ${MOBILE_L}px) {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  h3 {
    margin-bottom: 30px;
  }
`;

export const DoneWrapper = styled.div`
  font-size: 19px;
  font-weight: 800;
  margin-top: 90px;
  flex: 1;

  @media (max-width: ${MOBILE_L}px) {
    margin-top: 20px;
  }
`;

export const SlotSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
  width: min-content;
  align-items: center;
  min-width: 260px;
  h3 {
    line-height: 30px;
  }
  @media (max-width: ${MOBILE_L}px) {
    margin-right: 0;
  }
`;

export const Instruction = styled.span`
  color: #479de3;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  font-weight: 800;
  cursor: pointer;
  font-size: 12px;
  ${'' /* border: 2px solid red; */}
  text-align: center;
  ${'' /* height: 200px; */}
  p {
    margin-top: 8px;
    margin-bottom: 0;
    line-height: 1.5;
    display: inline-block;
    ${'' /* border: 1px solid purple; */}
  }
`;

export const ItemImageContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  ${'' /* height: 150px; */}
  ${'' /* padding-top: 50%; // 1:1 Aspect Ratio */}
  ${'' /* background-color: #f0f0f0; // Placeholder color */}
  ${'' /* border: 1px solid yellow; */} /* img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    object-fit: contain;
  } */
`;

export const ItemImage = styled.img`
  margin-bottom: 8px;
  width: 100%;
  height: auto;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ItemPanel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (max-width: ${MOBILE_L}px) {
    margin-left: 8%;
    margin-right: 8%;
  }

  @media (min-width: ${MOBILE_L}px) {
    margin-top: 25px;
  }
`;

export const CategorySelector = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

export const CategoryButton = styled.button`
  height: auto;
  padding: 10px;
  font-size 14px;
  border-radius: 3px;
  font-weight: 800;
  margin: 5px;
  width: 200px;
  color: ${(props) => (props.selected ? 'white' : '#479DE3')};
  border: ${(props) => (props.selected ? 'none' : '1px solid #479DE3')};
  background: ${(props) => (props.selected ? '#479DE3' : 'none')};
  pointer-events: ${(props) => (props.selected ? 'none' : 'initial')};
`;

export const ItemsGrid = styled.div`
  display: grid;
  gap: 15px;
  margin-top: 30px;
  grid-template-columns: repeat(${(props) => props.itemsMobile || 2}, 1fr);

  @media (max-width: ${MOBILE_L}px) {
    align-self: center;
    width: 100%;
  }

  @media (min-width: ${MOBILE_L}px) {
    grid-template-columns: repeat(${(props) => props.itemsDesktop || 3}, 1fr);
  }
`;

export const ItemImageBackgroundSelection = styled.img`
  width: 128px; // 8x10 aspect ratio
  height: 160px;
  object-fit: cover;
  position: relative;
  top: 0;
  left: 0;
  @media (max-width: ${MOBILE_L}px) {
    height: 120px;
    width: 96px; // adjusted to keep 8x10 ratio
  } ;
`;

export const PoseImage = styled.img`
  width: 128px; // 8x10 aspect ratio
  height: 160px;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;

  @media (max-width: ${MOBILE_L}px) {
    height: 120px;
    width: 96px; // adjusted to keep 8x10 ratio
  } ;
`;

export const ItemImageBackgroundWrapper = styled.div`
  width: 128px; // 8x10 aspect ratio
  height: 160px;
  position: relative;
  cursor: pointer;
  @media (max-width: ${MOBILE_L}px) {
    height: 120px;
    width: 96px; // adjusted to keep 8x10 ratio
  } ;
`;

export const BackgroundNamePriceWrapper = styled.div`
  position: relative;
  p {
    margin-top: 6px !important;
  }
`;

export const PersonalizationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  @media (max-width: ${MOBILE_L}px) {
    padding: 0;
  }
`;

export const ZoomButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  padding: 2px;
  box-sizing: content-box;
  cursor: pointer;
  z-index: 2;
  border-radius: 5px;
  &:hover {
    background-color: #479de3;
  }
`;

export const PoseSlotsRow = styled.div`
  display: grid;
  gap: 15px;
  margin-bottom: 20px;
  width: 100%;
  grid-template-columns: repeat(${(props) => props.itemsMobile || 2}, 1fr);

  @media (min-width: ${MOBILE_L}px) {
    grid-template-columns: repeat(${(props) => props.itemsDesktop || 3}, 1fr);
  }
`;

export const PoseSlotBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  color: #666;
  font-weight: 800;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  aspect-ratio: 3/4;

  @media (max-width: ${MOBILE_L}px) {
    font-size: 12px;
  }
`;

export const PoseSlotBoxFilled = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3/4;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
